import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AngularFirestore, AngularFirestoreCollection  } from '@angular/fire/firestore';
import { Item } from '../item';

@Component({
  selector: 'app-dblist',
  templateUrl: './dblist.component.html',
  styleUrls: ['./dblist.component.css']
})

export class DblistComponent implements OnInit {

    logo: string = '../../assets/logomessage.png';

    // 取得したドキュメントを格納
    private itemsCollection: AngularFirestoreCollection<Item>;
    items: Observable<Item[]>;
    
    /** ↓表示中のドキュメントページ */
    previousEntry: any = "";
    latestEntry: any = "";
    viewLength = 10;  // 表示件数
    viewTotal = 0;    // 総レコード数

    // DI（依存性注入する機能を指定）データベース・コレクション名がfunnysnowman。
    constructor(private db: AngularFirestore) {
      // 全レコードを取得
      this.itemsCollection = db.collection<Item>('funnysnowman', ref => {
        return ref.orderBy('timestamp', 'desc').limit(this.viewLength)
      })
    }

    ngOnInit() {
      /** Read: パスにあるドキュメントが変更されるとイベントが発生してデータを参照（ストリームに変換） */
      this.items = this.itemsCollection.valueChanges();   // データベースから読み込みしている。
    }


}